import React from 'react';
import { Toast } from '@workday/canvas-kit-react/toast';
import { checkIcon, exclamationCircleIcon } from '@workday/canvas-system-icons-web';
import { colors } from '@workday/canvas-kit-react/tokens';
import { ID_TOAST_SUCCESS, ID_TOAST_ERROR } from '../../autoIds';

export interface Message {
    id: string;
    text: string;
    type?: 'success' | 'error';
    timeInMillis?: number;
}

interface SystemMessageProps {
    message: Message;
    onClose?: (id: string) => void;
}

export const SystemMessage = ({ message, onClose }: SystemMessageProps) => {
    const isErrorToast = message.type === 'error';

    const iconColor = isErrorToast ? colors.cinnamon500 : colors.greenApple300;
    const icon = isErrorToast ? exclamationCircleIcon : checkIcon;

    return (
        <>
            {/* @ts-ignore */}
            <Toast
                mode={isErrorToast ? 'alert' : 'status'}
                data-testid={isErrorToast ? ID_TOAST_ERROR : ID_TOAST_SUCCESS}
                aria-label='notification'
                marginBottom={'xxs'}
                transformOrigin={{ horizontal: 'center', vertical: 'top' }}>
                <Toast.Icon icon={icon} color={iconColor} />
                <Toast.Body>
                    <Toast.Message>{message.text}</Toast.Message>
                </Toast.Body>
                <Toast.CloseIcon
                    aria-label='Close'
                    onClick={() => {
                        if (onClose) {
                            onClose(message.id);
                        }
                    }}
                />
            </Toast>
        </>
    );
};
